export default (css, palette) => {
    const legacy = css`
      --white-fg: ${palette.White};
      --text: ${palette.Grey50};

      --primary: #0067C5;
      --secondary: #2359A3;
      --primary-disabled: #93B3E5;
      --secondary-light-1: #1FA0FF;
      --secondary-light-2: #98D5FF;

      --grey-3: #f1f1f1;
      --grey-4: #e0e0e0;
      --grey-5: #c8c8c8;
      --grey-6: #a7a7a7;
      --grey-7: #838383;

      --Grey400: #a7a7a7;
      --Grey500: #6f6f6f;
      --Grey200: #e0e0e0;

      --light-bg: #fbfbfb;

      --infographic-1: #151376;
      --infographic-2: #168FAB;
      --infographic-3: #6955DC;
      --infographic-4: #87489D;
      --infographic-5: #DB4CD6;
      --infographic-6: #48DBFD;
      --infographic-7: #1FA0FF;
      --infographic-8: #3BD9A2;
      --infographic-9: #EE5959;
      --infographic-10: #F0BA6A;
    `;

    const bg = css`
      --main-background: ${palette.Grey10};
      --main-background-rgb: ${palette.Grey10_RGB};
      --content-background: ${palette.White};
      --hover-background: ${palette.Blue10};
      --table-header-background: ${palette.Blue20};
      --mask-background: ${palette.Grey50};
    `;

    const text = css`
      --text-primary: ${palette.Grey50};
      --text-secondary: ${palette.Grey45};
      --text-disabled: ${palette.Grey30};
      --text-title: ${palette.Blue70};
      --text-button-primary: ${palette.Blue70};
      --text-button-primary-hover: ${palette.Blue80};
      --text-button-secondary: ${palette.Grey45};
      --text-button-secondary-hover: ${palette.Grey50};
      --text-button-disabled: ${palette.Grey30};
      --text-button-light: ${palette.Blue70};
      --text-on-color: ${palette.White};
      --header-bluexp-sub-title-hover: ${palette.Blue30};
    `;

    const buttons = css`
      --button-primary-bg: ${palette.Blue70};
      --button-primary-bg-hover: ${palette.Blue80};
      --button-primary-bg-disabled: ${palette.Grey15};
      --button-primary-disabled: ${palette.Grey30};
      --button-secondary: ${palette.Blue70};
      --button-secondary-hover: ${palette.Blue80};
      --button-secondary-disabled: ${palette.Grey30};
      --button-card-footer: ${palette.Blue10};
      --button-card-footer-hover: ${palette.Blue20};
      --button-destructive-bg: ${palette.Red30};
      --button-destructive-bg-hover: ${palette.Red40};
    `;

    const icons = css`
      --icon-primary: ${palette.Blue70};
      --icon-primary-hover: ${palette.Blue80};
      --icon-primary-disabled: ${palette.Grey30};

      --icon-secondary: ${palette.Grey50};
      --icon-secondary-hover: ${palette.Grey45};
      --icon-secondary-disabled: ${palette.Grey30};

      --icon-tertiary: ${palette.Grey45};
      --icon-tertiary-hover: ${palette.Grey40};
      --icon-tertiary-disabled: ${palette.Grey30};
      
      --icon-on-color-white: ${palette.White};

      --icon-on-color: ${palette.White};

      --icon-round-border: ${palette.Grey15};
    `;

    const tooltip = css`
      --tooltip-icon-default: ${palette.Grey30};
      --tooltip-icon-hover: ${palette.Blue70};
      --tooltip-icon-disabled: ${palette.Grey15};
      --tooltip-info-bg: ${palette.White};
    `;

    const notifications = css`
      --error: ${palette.Red30};
      --error-bg: ${palette.Red10};
      --warning: ${palette.Orange60};
      --warning-bg: ${palette.Orange10};
      --information: ${palette.Cyan30};
      --information-bg: ${palette.Cyan10};
      --info: ${palette.Cyan30};
      --info-bg: ${palette.Cyan10};
      --success: ${palette.Green60};
      --success-bg: ${palette.Green10};
      --group-item-bg: ${palette.White};
    `;

    const other = css`
      --border: ${palette.Grey15};

      --drop-shadow: ${palette.Grey15};

      --underline-default: ${palette.Grey30};
      --underline-selected: ${palette.Blue70};

      --scroller: ${palette.Grey25};

      --focus-outline: ${palette.Blue70};
      --focus-outline-header: ${palette.White};

      --scroller-track: #eee;
      
      --drop-shadow-dialogs: ${palette.Grey45};
    `;

    const shell = css`
      --main-nav-bg: ${palette.White};
      --main-nav-bg-hover: ${palette.Grey10};
      --main-nav-bg-selected: ${palette.Blue10};
      --main-nav-icon-text: ${palette.Grey45};
      --main-nav-icon-text-selected: ${palette.Blue70};

      --browser-primary-bg: ${palette.Grey15};
      --browser-secondary-bg: ${palette.Grey15};
      --browser-bg-stroke: ${palette.Grey25};
      --browser-text-field: ${palette.White};
      --browser-nav-icons: ${palette.Grey30};

      --header-netapp-bg: ${palette.Blue70};
      --header-service-bg: ${palette.White};
      --header-netapp-primary-text: ${palette.White};
      --header-netapp-secondary-text: ${palette.Blue10};
      --header-netapp-icons: ${palette.White};
      --header-netapp-text-hover: ${palette.Blue30};
      --header-notification-text: ${palette.Blue80};
      --header-notification-text-2: ${palette.White};
      --header-separator-1: ${palette.White};
      --header-separator-2: ${palette.White};
    `;

    const chart = css`
      --chart-1: ${palette.Cyan70};
      --chart-2: ${palette.Cyan20};
      --chart-3: ${palette.Cyan50};
      --chart-4: ${palette.Green50};
      --chart-5: ${palette.Green30};
      --chart-6: ${palette.Orange40};
      --chart-7: ${palette.Orange50};
      --chart-8: ${palette.Orange70};
      --chart-9: ${palette.Purple20};
      --chart-10: ${palette.Purple30};
      --chart-11: ${palette.Purple15};
      --chart-3-gradient: ${palette.Cyan50};
      --chart-9-gradient: ${palette.Purple20};
      --chart-background: ${palette.Purple03};
      --chart-disabled: ${palette.Grey15};
    `;

    const pieChart = css`
      --pieChart-1: ${palette.Cyan70};
      --pieChart-2: ${palette.Cyan20};
      --pieChart-3: ${palette.Cyan50};
      --pieChart-4: ${palette.Purple30};
      --pieChart-5: ${palette.Purple70};
      --pieChart-6: ${palette.Purple60};
      --pieChart-7: ${palette.Green50};
      --pieChart-8: ${palette.Purple80};
      --pieChart-9: ${palette.Purple40};
      --pieChart-10: ${palette.Grey20};
      --pieChart-disabled: ${palette.Grey60};
    `;

    const tag = css`
      --tag-1-text: ${palette.Cyan70};
      --tag-1-bg: ${palette.Blue25};
      --tag-2-text: ${palette.Purple25};
      --tag-2-bg: ${palette.Purple01};
      --tag-3-text: ${palette.Blue80};
      --tag-3-bg: ${palette.Purple02};
      --tag-4-text: ${palette.Orange90};
      --tag-4-bg: ${palette.Orange12};
    `;

    const selectors = css`
      --selector-off-border: ${palette.Grey50};
      --selector-off-border-hover: ${palette.Grey45};
      --selector-off-border-disabled: ${palette.Grey30};
      --selector-off-bg-disabled: ${palette.Grey10};
      --selector-on-bg: ${palette.Blue70};
      --selector-on-bg-disabled: ${palette.Grey30};
      --selector-on-bg-hover: ${palette.Blue80};
      --toggle-off: ${palette.White};
      --toggle-off-bg: ${palette.Grey25};
      --toggle-off-disabled: ${palette.Grey25};
      --toggle-off-bg-hover: ${palette.Grey30};

      --date-picker-bg: ${palette.Grey10};

      --item-selection-bg: ${palette.Grey10};
      --item-selection-border: ${palette.White};
    `;

    const loaders = css`
      --loader-wheel-line: ${palette.Blue70};
      --loader-line-bg: ${palette.Grey15};
      --loader-dot: ${palette.Cyan30};
      --loader-skeleton: ${palette.Grey15};
      --loader-skeleton-bg: ${palette.Grey10};
    `;

    const fields = css`
      --field-border: ${palette.Grey30};
      --field-border-disabled: ${palette.Grey25};
      --field-bg-disabled: ${palette.Grey10};
      --field-border-selected: ${palette.Blue70};
      --field-icon: ${palette.Grey45};
      --field-icon-disabled: ${palette.Grey25};
    `;

    const thirdPartyTokens = css`
        --third-party-aws-smile: #FF9900;
        --third-party-aws-text: #252F3E;
    `;

    const canvas = css`
      --canvas-cloud-shadow: ${palette.Grey25};
    `;

    return [legacy, bg, text, tooltip, buttons, icons, notifications, other, shell, chart, selectors, loaders, fields, thirdPartyTokens, canvas, tag, pieChart].join("\n");
}